import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAll(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/groupes', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        fetch(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/groupes/' + payload.groupe_id)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        groupeStore(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/groupes/store', payload)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
    },
}
